import LightbulbCircleIcon from '@mui/icons-material/LightbulbCircle';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { StyAlert } from 'routes/HumanResourcesModule/components/ui/StyAlert';

const StyGrower = styled('div', { name: 'StyGrower' })(() => ({
    flexGrow: 1,
}));

const HelperAlert = ({
    children,
    className,
}: {
    children: React.ReactElement;
    className?: string;
}) => {
    const [show, setShow] = useState(true);
    if (!show) return <></>;
    return (
        <StyAlert
            className={className}
            severity="info"
            icon={<LightbulbCircleIcon />}
            onClose={() => setShow(false)}
        >
            {/*<LightbulbCircleIcon
                color="primary"
                sx={{
                    width: 24,
                    height: 24,
                    flexShrink: 0,
                    flexGrow: 0,
                }}
            />*/}
            <StyGrower>{children}</StyGrower>
        </StyAlert>
    );
};

export default HelperAlert;
